// workerPool.js
// import WorkerScript from '@/workers/cacheWorker.js?worker';

export class WorkerPool {
  constructor(workerUrl, maxWorkers = 6) {
    this.maxWorkers = maxWorkers;
    this.workerQueue = [];
    this.activeWorkers = 0;
    this.workerPool = [];
    this.listeners = [];
    this.workerStatus = new Map(); // Track busy workers

    for (let i = 0; i < maxWorkers; i++) {
      //   const worker = new Worker(workerUrl);
      const worker = new Worker(new URL('./cacheWorker.js', import.meta.url), {
        type: 'module',
      });
      // Track worker status
      this.workerStatus.set(worker, false); // false = available

      // Listen for messages from each worker
      worker.onmessage = (event) => {
        if (event.data.error) {
          this.handleWorkerError(event.data.error, worker);
        }

        // console.log('Worker response:', event);
        this.workerStatus.set(worker, false); // Mark worker as available
        this.activeWorkers--;

        this.notifyListeners({
          type: 'result',
          data: event.data,
        });

        // Process next task in the queue if available
        if (this.workerQueue.length > 0) {
          this.assignTask(this.workerQueue.shift());
        }
      };

      // Listen for errors from each worker
      worker.onerror = (errorEvent) => this.handleWorkerError(errorEvent.error, worker);

      this.workerPool.push(worker);
    }
  }

  addTask(taskData) {
    if (this.activeWorkers < this.maxWorkers) {
      this.assignTask(taskData);
    } else {
      // console.log('Queueing task', taskData);
      this.workerQueue.push(taskData);
    }
  }

  assignTask(taskData) {
    const worker = this.getAvailableWorker();
    if (worker) {
      this.activeWorkers++;
      this.workerStatus.set(worker, true); // Mark worker as busy

      // Notify that the worker has started processing
      this.notifyListeners({
        type: 'started',
        worker,
        data: taskData,
      });

      // console.log('Assigning task:', taskData);
      worker.postMessage(taskData);
    } else {
      console.warn('No available worker, adding to queue');
      this.workerQueue.push(taskData);
    }
  }

  getAvailableWorker() {
    return [...this.workerStatus.keys()].find((worker) => !this.workerStatus.get(worker));
  }

  notifyListeners(data) {
    // console.log('notifyListeners');
    this.listeners.forEach((listener) => listener(data));
  }

  onmessage(callback) {
    // console.log('onmessage');
    this.listeners.push(callback);
  }

  terminate() {
    this.workerPool.forEach((worker) => worker.terminate());
  }

  clearQueue() {
    // console.log('Clearing pending tasks');
    this.workerQueue = [];
  }

  getQueue() {
    return this.workerQueue;
  }

  handleWorkerError(error, worker) {
    console.error('Worker error:', error.message);
    this.workerStatus.set(worker, false); // Free up worker
    this.activeWorkers--; // Prevent deadlock

    // Process next task
    if (this.workerQueue.length > 0) {
      this.assignTask(this.workerQueue.shift());
    }
  }

  restartWorkers() {
    // Terminate all existing workers
    this.workerPool.forEach((worker) => worker.terminate());

    // Clear the worker pool, status map, and queue
    this.workerPool = [];
    this.workerStatus.clear();
    this.workerQueue = [];
    this.activeWorkers = 0;

    // Create new workers
    for (let i = 0; i < this.maxWorkers; i++) {
      const worker = new Worker(new URL('./cacheWorker.js', import.meta.url), {
        type: 'module',
      });

      this.workerStatus.set(worker, false); // Mark as available

      worker.onmessage = (event) => {
        if (event.data.error) {
          this.handleWorkerError(event.data.error, worker);
        }

        this.workerStatus.set(worker, false);
        this.activeWorkers--;

        this.notifyListeners({
          type: 'result',
          data: event.data,
        });

        if (this.workerQueue.length > 0) {
          this.assignTask(this.workerQueue.shift());
        }
      };

      worker.onerror = (errorEvent) => this.handleWorkerError(errorEvent.error, worker);

      this.workerPool.push(worker);
    }
  }
}
